<!--  -->
<template>
  <div v-loading.body="loading">
    <!-- <div class="doctor-details">
      <img alt :src="g_imgSrc.rightArrow" class="doctor-details-img" @click="Goback" />
      <div class="doctor-details-return" @click="Goback">返回</div>
    </div> -->
    <div class="contant">
      <el-form :model="form" inline class="strategy-name">
        <h4 style="margin-bottom: 20px">策略名称</h4>
        <el-form-item label="策略名称:" label-width="120">
          <el-input
            show-word-limit
            v-model.trim="form.strategy_name"
            class="Strategy-input"
            placeholder="请输入策略名称"
            :maxlength="6"
            clearable
          />
        </el-form-item>
      </el-form>
      <div class="project">
        <h4>策略项目</h4>
        <el-checkbox-group class="field-choose" v-model="strategy_items" @change="handleChange">
          <el-checkbox v-for="item in strategy_Options" :label="item.id" :key="item.id">
            {{ item.name }}
          </el-checkbox>
        </el-checkbox-group>
        <div class="condition">
          <el-form>
            <!-- 领域 -->
            <el-form-item label="1.领域:">
              <el-tag
                style="margin-left: 8px"
                v-for="tag in strategy_Options[0].data"
                :key="tag.id"
                closable
                @close="handleCloseTag(strategy_Options[0].data, tag)"
              >
                {{ tag | optionsfieldLabel(addDomain_ids) }}
              </el-tag>
              <el-button
                type="text"
                style="margin-left: 20px"
                @click="openFieldTag"
                :disabled="!strategy_items.includes('1')"
              >
                +添加
              </el-button>
              <el-dialog title="添加关注领域" :visible.sync="fieldVisible">
                <el-form>
                  <el-form-item label="关注领域">
                    <el-select v-model="addDomain_name" placeholder="请选择领域">
                      <el-option
                        v-for="item in addDomain_ids"
                        :key="item.id"
                        :value="item.domain_name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="fieldVisible = false">取 消</el-button>
                  <el-button type="primary" @click="handleAddDomain">确 定</el-button>
                </div>
              </el-dialog>
            </el-form-item>
            <!-- 科室 -->
            <el-form-item label="2.科室:">
              <el-tag
                style="margin-left: 8px"
                v-for="tag in strategy_Options[1].data"
                :key="tag.id"
                closable
                @close="handleCloseTag(strategy_Options[1].data, tag)"
              >
                {{ tag | optionsDeparmentLabel(addDepartment) }}
              </el-tag>
              <el-button
                type="text"
                style="margin-left: 20px"
                @click="openDepartment"
                :disabled="!strategy_items.includes('2')"
              >
                +添加
              </el-button>
              <el-dialog title="添加关注科室" :visible.sync="departmentVisible">
                <el-form>
                  <el-form-item label="关注科室">
                    <el-select v-model="deparment_name" placeholder="请选择科室">
                      <el-option
                        v-for="item in addDepartment"
                        :key="item.department_id"
                        :value="item.department_name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="departmentVisible = false">取 消</el-button>
                  <el-button type="primary" @click="handleAddDeparment">确 定</el-button>
                </div>
              </el-dialog>
            </el-form-item>
            <!-- 医生职称 -->
            <el-form-item label="3.医生职称:">
              <el-tag
                style="margin-left: 8px"
                v-for="tag in strategy_Options[2].data"
                :key="tag.title_id"
                closable
                @close="handleCloseTag(strategy_Options[2].data, tag)"
              >
                {{ tag | optionsDoctorLabel(addDoctorTitle) }}
              </el-tag>
              <el-button
                type="text"
                style="margin-left: 20px"
                @click="openDoctorTitle"
                :disabled="!strategy_items.includes('3')"
              >
                +添加
              </el-button>
              <el-dialog title="添加医生职称" :visible.sync="doctorTitleVisible">
                <el-form>
                  <el-form-item label="医生职称">
                    <el-select v-model="addDoctor_title" placeholder="请选择医生职称">
                      <el-option
                        v-for="item in addDoctorTitle"
                        :key="item.title_id"
                        :value="item.title_name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="doctorTitleVisible = false">取 消</el-button>
                  <el-button type="primary" @click="handleAddDoctorTitle">确 定</el-button>
                </div>
              </el-dialog>
            </el-form-item>
            <!-- 医生等级 -->
            <el-form-item label="4.医生等级:">
              <el-checkbox-group
                :disabled="!strategy_items.includes('4')"
                v-model="strategy_Options[3].data"
              >
                <el-checkbox v-for="item in doctorList" :label="item.id" :key="item.value">
                  {{ item.value }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <!-- 医生性别 -->
            <el-form-item label="5.医生性别:">
              <el-radio
                :disabled="!strategy_items.includes('5')"
                v-model="strategy_Options[4].data"
                v-for="item in genderList"
                :label="item.id"
                :key="item.value"
              >
                {{ item.id | optionsLabel(genderList) }}
              </el-radio>
            </el-form-item>
            <!-- 省市区 -->
            <el-form-item label="6.省市区:">
              省
              <el-select
                clearable
                v-model="strategy_Options[5].data.province_code"
                placeholder="请选择省"
                :disabled="!strategy_items.includes('6')"
                @focus="handleSelectProvince"
                @change="handleSelectCity('City', strategy_Options[5].data.province_code)"
              >
                <el-option
                  v-for="item in provinceList"
                  :key="item.area_code"
                  :label="item.area_name"
                  :value="item.area_code"
                ></el-option>
              </el-select>

              市
              <el-select
                clearable
                v-model="strategy_Options[5].data.city_code"
                placeholder="请选择市"
                :disabled="!strategy_items.includes('6')"
                @focus="handleSelectCity('City', strategy_Options[5].data.province_code)"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.area_code"
                  :label="item.area_name"
                  :value="item.area_code"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 所属医院 -->
            <el-form-item label="7.所属医院:">
              <el-select
                clearable
                filterable
                v-model="addHospital"
                :filter-method="handleSearchHospitals"
                placeholder="输入关键字搜索"
                :disabled="!strategy_items.includes('7')"
                @change="handleAddHospital"
                style="width: 300px"
              >
                <el-option
                  v-for="item in hospitalList"
                  :key="item.hospital_id"
                  :label="item.hospital_name"
                  :value="{ hospital_id: item.hospital_id, hospital_name: item.hospital_name }"
                ></el-option>
              </el-select>
              <el-tag
                v-for="tag in addHospitalList"
                :key="tag.hospital_id"
                closable
                @close="removeAddHospital(tag)"
              >
                {{ tag.hospital_name }}
              </el-tag>
            </el-form-item>
          </el-form>
        </div>
        <el-form inline>
          <el-form-item label="使用逻辑:" label-width="120">
            <el-input
              style="width: 400px"
              show-word-limit
              v-model.trim="strategy_relation"
              class="Strategy-input"
              placeholder="请输入策略名称"
              :maxlength="20"
              clearable
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="release-public">
        <h4 style="margin-bottom: 30px">发布公众号</h4>
        <el-form inline>
          <!-- 公众号 -->
          <el-form-item label="公众号:">
            <el-tag
              style="margin-left: 8px"
              v-for="tag in app_ids"
              :key="tag.id"
              closable
              @close="handleCloseTag(app_ids, tag)"
            >
              {{ tag | optionsAppIdLabel(appIdList) }}
            </el-tag>
            <el-button type="text" style="margin-left: 20px" @click="openAppIdTag">+添加</el-button>
            <el-dialog title="发布公众号" :visible.sync="appIdVisible">
              <el-form>
                <el-form-item label="发布公众号">
                  <el-select v-model="addAppId" placeholder="请选择公众号">
                    <el-option
                      v-for="item in appIdList"
                      :key="item.app_id"
                      :disabled="item.status === 2"
                      :value="item.app_name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="appIdVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleAddAppId">确 定</el-button>
              </div>
            </el-dialog>
          </el-form-item>
        </el-form>
      </div>
      <div class="note">
        <h4>备注</h4>
        <el-form inline>
          <el-form-item label="备注：">
            <el-input
              style="width: 400px"
              show-word-limit
              v-model.trim="form.remark"
              class="Strategy-input"
              placeholder="请输入备注"
              :maxlength="20"
              clearable
            />
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-button type="primary" @click="Submit()" class="pubic-button">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetDomainInfoList,
  // getAppListApi,
  CreateStrategyInfo,
  updateStrategyInfo,
  getStrategyDetail,
} from '@/api/setUser.js';
import {
  GetKvList,
  getAreaList,
  queryPagesApi,
  getHospitalDepartmentListApi,
  QueryTitleList,
} from '@/api/setUp.js';
import { debounce } from '@/libs/utils/util';
export default {
  filters: {
    optionsLabel(val, options = []) {
      for (const item of options) {
        if (Number(item.id) === Number(val)) {
          return item.value;
        }
      }
      return '无';
    },
    optionsDeparmentLabel(val, options = []) {
      for (const item of options) {
        if (Number(item.department_id) === Number(val)) {
          return item.department_name;
        }
      }
      return '无';
    },
    optionsfieldLabel(val, options = []) {
      for (const item of options) {
        if (Number(item.id) === Number(val)) {
          return item.domain_name;
        }
      }
      return '无';
    },
    optionsDoctorLabel(val, options = []) {
      for (const item of options) {
        if (Number(item.title_id) === Number(val)) {
          return item.title_name;
        }
      }
      return '无';
    },
    optionsAppIdLabel(val, options = []) {
      for (const item of options) {
        if (item.app_id === val) {
          return item.app_name;
        }
      }
      return '无';
    },
  },
  data() {
    return {
      form: {
        strategy_name: '', // 策略名字
        remark: '', // 备注
      },
      loading: false,
      fieldVisible: false,
      departmentVisible: false,
      doctorTitleVisible: false,
      appIdVisible: false,
      strategy_relation: '1且2且3且4且5且6且7', // 使用逻辑
      area_code: '', // 区code
      area: '', // 区名称
      province_code: '', // 省code
      province: '', // 省名称
      city_code: '', // 市code
      city: '', // 市名称
      areaList: [], // 获取区列表
      cityList: [], // 获取市列表
      provinceList: [], // 获取省列表
      app_ids: [], // 公众号
      // appIdList: [], // 添加公众号列表
      addAppId: '', // 添加公众号值
      gender: 0, // 医生性别
      genderList: [], // 获取性别列表
      doctor_levels: [], // 医生等级
      doctorList: [], // 获取医生等级列表
      doctor_title_ids: [], // 医生职称
      addDoctorTitle: [], // 添加医生职称列表
      addDoctor_title: '', // 添加医生职称值
      doctor_department_ids: [], // 科室
      addDepartment: [], // 添加科室列表
      deparment_name: '', // 添加科室值
      domain_ids: [], // 领域
      addDomain_ids: [], // 添加领域列表
      addDomain_name: '', // 添加领域值
      hospitalList: [], // 医院列表
      addHospital: '',
      addHospitalList: [], // 选择的医院列表
      strategy_Options: [
        { id: '1', name: '1.领域', data: [] },
        { id: '2', name: '2.科室', data: [] },
        { id: '3', name: '3.医生职称', data: [] },
        { id: '4', name: '4.医生等级', data: [] },
        { id: '5', name: '5.医生性别', data: 0 },
        {
          id: '6',
          name: '6.省市区',
          data: { province_code: '', city_code: '', province: '', city: '' },
        },
        {
          id: '7',
          name: '7.所属医院',
          data: [],
        },
      ],
      strategy_items: [], // 勾选选择
    };
  },
  computed: {
    appIdList() {
      return this.$store.state.user.managerLogin.app_list.map((item) => ({
        app_name: item.app_name,
        app_id: item.app_id,
        type: item.type,
        status: Number(item.status),
      }));
    },
  },
  created() {
    let title = '新建策略';
    if (this.$route.query.type === 'edit') {
      title = '编辑策略';
    }
    const breadcrumb = [
      { menu_name: '设置', menu_path: '' },
      { menu_name: '策略设置', menu_path: 'strategySetting' },
      { menu_name: title },
    ];
    this.$store.commit('user/setBreadcrumb', breadcrumb);

    if (this.$route.query.type === 'edit') {
      this.loading = true;
      getStrategyDetail({ id: this.$route.query.id })
        .then((res) => {
          // 这边序号从0开始，strategy_Options里面的序号从1开始
          this.form.strategy_name = res.strategy_name;
          this.strategy_Options[0].data = res.domain_ids;
          this.strategy_Options[1].data = res.doctor_department_ids;
          this.strategy_Options[2].data = res.doctor_title_ids;
          this.strategy_Options[3].data = res.doctor_levels;
          this.strategy_Options[4].data = res.gender;
          this.strategy_Options[5].data.province_code = res.province_code;
          this.strategy_Options[5].data.province = res.province;
          this.strategy_Options[5].data.city_code = res.city_code;
          this.strategy_Options[5].data.city = res.city;
          this.addHospitalList = res.hospitals;
          this.area_code = res.area_code;
          this.area = res.area;
          this.form.remark = res.remark;
          this.strategy_relation = res.strategy_relation;
          this.strategy_items = res.strategy_items;
          this.app_ids = res.app_ids;
          // const str = this.strategy_relation.replace(/and/g, '且');
          // const newStr = str.replace(/or/g, '或');
          // this.strategy_relation = newStr;
          this.handleSelectProvince();
          if (this.strategy_Options[5].data.province_code !== '') {
            getAreaList({
              type: 'City',
              area_code: this.strategy_Options[5].data.province_code,
            }).then((res) => {
              // console.log(res);
              this.cityList = res.data;
            });
          }
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    }
    GetDomainInfoList()
      .then((res) => {
        // console.log(res);
        const arr = res.list || [];
        arr.forEach((item) => {
          if (item.status === 1) {
            this.addDomain_ids.push(item);
          }
        });
      })
      .catch((err) => {
        this.$message.error(err.message);
      });
    getHospitalDepartmentListApi()
      .then((res) => {
        // console.log(res);
        this.addDepartment = res.data || [];
      })
      .catch((err) => {
        this.$message.error(err.message);
      });
    QueryTitleList({ page_index: 1, page_size: 9999 })
      .then((res) => {
        // console.log(res);
        this.addDoctorTitle = res.data || [];
      })
      .catch((err) => {
        this.$message.error(err.message);
      });
    GetKvList({ type: 'doctor_level' })
      .then((res) => {
        // console.log(res);
        const arr = res.list;
        const newArr = arr.map((item) => {
          return { id: item.key, value: item.value };
        });
        this.doctorList = newArr;
      })
      .catch((err) => {
        this.$message.error(err.message);
      });
    GetKvList({ type: 'gender' })
      .then((res) => {
        // console.log(res);
        const arr = res.list;
        const newArr = arr.map((item) => {
          return item.key_type === 'INT'
            ? { id: Number(item.key), value: item.value }
            : { id: item.key, value: item.value };
        });
        this.genderList = newArr;
      })
      .catch((err) => {
        this.$message.error(err.message);
      });
    // getAppListApi({
    //   enterprise_id: this.$store.getters['user/getEnterpriseId'],
    //   page_index: 1,
    //   page_size: 999,
    // })
    //   .then((res) => {
    //     this.appIdList = res.list;
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //     this.$message.error('查询发布渠道失败');
    //   });

    this.handleSearchHospitals('');
  },
  methods: {
    // 输入医院名称后搜索二十条记录
    handleSearchHospitals(keyword) {
      console.log(keyword);
      const temp = debounce(
        () => {
          queryPagesApi({
            page_index: 1,
            page_size: 20,
            hospital_name: keyword,
          }).then((res) => {
            console.log(res);
            this.hospitalList = res.data;
          });
        },
        300,
        false,
      );
      temp();
    },
    handleAddHospital(item) {
      if (item !== '') {
        console.log(item);
        const ids = this.addHospitalList.map((item) => item.hospital_id);
        if (ids.includes(item.hospital_id)) {
          this.$message.warning('已添加的医院不能重复添加');
        } else {
          this.addHospitalList.push({ ...item });
        }
        this.addHospital = '';
      }
    },
    removeAddHospital(tag) {
      this.addHospitalList.splice(this.addHospitalList.indexOf(tag), 1);
    },
    typeOf(obj) {
      const { toString } = Object.prototype;
      const map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object',
      };
      return map[toString.call(obj)];
    },
    handleChange(val) {
      const selectOption = ['1', '2', '3', '4', '5', '6'];
      const arr = selectOption.filter((item) => {
        return !new Set(val).has(item);
      });
      for (const item of arr) {
        if (
          this.typeOf(this.strategy_Options[item - 1].data) === 'array' &&
          this.strategy_Options[item - 1].data.length !== 0
        ) {
          this.$confirm('确认清空当前选择项？')
            .then(() => {
              this.strategy_Options[item - 1].data = [];
            })
            .catch(() => {
              // arr = arr.filter(i=>i!==item)
              this.strategy_items.push(item);
            });
        } else if (
          this.typeOf(this.strategy_Options[item - 1].data) === 'object' &&
          Object.values(this.strategy_Options[item - 1].data)[0] !== ''
        ) {
          this.$confirm('确认清空当前选择项？')
            .then(() => {
              this.strategy_Options[item - 1].data = {
                province_code: '',
                city_code: '',
                province: '',
                city: '',
              };
            })
            .catch(() => {
              // arr = arr.filter(i=>i!==item)
              this.strategy_items.push(item);
            });
        } else if (
          this.typeOf(this.strategy_Options[item - 1].data) === 'number' &&
          this.strategy_Options[item - 1].data !== 0
        ) {
          this.$confirm('确认清空当前选择项？')
            .then(() => {
              this.strategy_Options[item - 1].data = 0;
            })
            .catch(() => {
              // arr = arr.filter(i=>i!==item)
              this.strategy_items.push(item);
            });
        }
      }
    },
    Goback() {
      this.$router.go(-1);
    },
    handleSelectProvince() {
      // 获取省
      getAreaList({ type: 'Province' })
        .then((res) => {
          this.loading = false;
          this.provinceList = res.data;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    handleSelectCity(type, code) {
      // 获取市
      this.strategy_Options[5].data.city_code = '';
      if (code === '') {
        this.cityList = [];
        return;
      }
      getAreaList({ type, area_code: code }).then((res) => {
        this.cityList = res.data;
      });
    },
    handleAddAppId() {
      this.appIdList.forEach((item) => {
        if (item.app_name === this.addAppId) {
          this.app_ids.push(item.app_id);
        }
      });
      this.app_ids = [...new Set(this.app_ids)];
      this.appIdVisible = false;
    },
    handleAddDoctorTitle() {
      if (this.strategy_Options[2].data.length >= 15) {
        this.$message.error('最多添加5个医生职称');
        return false;
      }
      this.addDoctorTitle.forEach((item) => {
        if (item.title_name === this.addDoctor_title) {
          this.strategy_Options[2].data.push(item.title_id);
        }
      });
      this.strategy_Options[2].data = [...new Set(this.strategy_Options[2].data)];
      // this.strategy_Options[2].data = this.doctor_title_ids;
      this.doctorTitleVisible = false;
    },
    handleAddDomain() {
      if (this.strategy_Options[0].data.length >= 15) {
        this.$message.error('最多添加15个领域');
        return false;
      }
      this.addDomain_ids.forEach((item) => {
        if (item.domain_name === this.addDomain_name) {
          this.strategy_Options[0].data.push(String(item.id));
        }
      });
      this.strategy_Options[0].data = [...new Set(this.strategy_Options[0].data)];
      // this.strategy_Options[0].data = this.domain_ids;
      this.fieldVisible = false;
    },
    handleAddDeparment() {
      if (this.strategy_Options[1].data.length >= 5) {
        this.$message.error('最多添加5个科室');
        return false;
      }
      this.addDepartment.forEach((item) => {
        if (item.department_name === this.deparment_name) {
          this.strategy_Options[1].data.push(item.department_id);
        }
      });
      this.strategy_Options[1].data = [...new Set(this.strategy_Options[1].data)];
      // this.strategy_Options[1].data = this.doctor_department_ids;
      this.departmentVisible = false;
    },
    handleCloseTag(arr, tag) {
      arr.splice(arr.indexOf(tag), 1);
    },
    openAppIdTag() {
      this.appIdVisible = true;
    },
    openDoctorTitle() {
      this.doctorTitleVisible = true;
    },
    openFieldTag() {
      this.fieldVisible = true;
    },
    openDepartment() {
      this.departmentVisible = true;
    },
    Submit() {
      if (this.strategy_items.length === 0) {
        this.$message.error('请至少勾选一种策略项目');
        return false;
      }
      for (let i = 0; i < this.strategy_items.length; i++) {
        if (this.strategy_relation.indexOf(this.strategy_items[i]) < 0) {
          this.$message.error('使用逻辑与勾选不符合');
          return false;
        }
      }
      // const str = this.strategy_relation.replace(/且/g, 'and');
      // const newStr = str.replace(/或/g, 'or');
      // console.log(newStr);
      const req = {
        strategy_name: this.form.strategy_name,
        domain_ids: this.strategy_Options[0].data,
        province_code: this.strategy_Options[5].data.province_code,
        province: this.strategy_Options[5].data.province,
        city_code: this.strategy_Options[5].data.city_code,
        city: this.strategy_Options[5].data.city,
        // area_code: this.area_code,
        // area: this.area,
        gender: this.strategy_Options[4].data ?? 0,
        remark: this.form.remark,
        doctor_title_ids: this.strategy_Options[2].data,
        doctor_levels: this.strategy_Options[3].data,
        doctor_department_ids: this.strategy_Options[1].data,
        strategy_relation: this.strategy_relation,
        strategy_items: this.strategy_items,
        app_ids: this.app_ids,
        hospital_ids: this.addHospitalList.map((item) => item.hospital_id),
      };
      if (this.$route.query.type === 'add') {
        if (req.province_code !== '') {
          this.provinceList.forEach((item) => {
            if (item.area_code === req.province_code) {
              req.province = item.area_name;
            }
          });
        }
        if (req.city_code !== '') {
          this.cityList.forEach((item) => {
            if (item.area_code === req.city_code) {
              req.city = item.area_name;
            }
          });
        }
        console.log(req);
        CreateStrategyInfo(req)
          .then(() => {
            this.$message.success('添加策略成功！');
            this.$router.go(-1);
          })
          .catch((err) => {
            this.$message.error(err.message);
          });
      } else {
        if (req.province_code !== '') {
          this.provinceList.forEach((item) => {
            if (item.area_code === req.province_code) {
              req.province = item.area_name;
            }
          });
        }
        if (req.city_code !== '') {
          this.cityList.forEach((item) => {
            if (item.area_code === req.city_code) {
              req.city = item.area_name;
            }
          });
        }
        // console.log(req);
        updateStrategyInfo({ ...req, id: this.$route.query.id })
          .then(() => {
            this.$message.success('编辑策略成功！');
            this.$router.go(-1);
          })
          .catch((err) => {
            this.$message.error(err.message);
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.doctor-details {
  position: relative;
  height: 80px;
  // border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #303133;
  .doctor-details-img {
    position: absolute;
    top: 32.5px;
    left: 0;
    width: 24px;
    height: 24px;
    transform: rotateY(180deg);
  }
  .doctor-details-return {
    position: absolute;
    top: 36px;
    width: 44px;
    height: 22px;
    left: 28px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #606266;
    letter-spacing: 0;
    cursor: pointer;
  }
  .doctor-details-return:hover {
    color: rgb(47, 150, 255);
  }
}
.strategy-name {
  height: 100px;
  border-bottom: 1px solid rgb(242, 243, 245);
}
.project {
  box-sizing: border-box;
  padding: 20px 0 25px 0;
  border-bottom: 1px solid rgb(242, 243, 245);
}
.field-choose {
  margin-top: 15px;
}
.condition {
  // height: 270px;
  margin: 20px 0 20px 0;
  background: rgba(247, 249, 252);
  box-sizing: border-box;
  padding: 20px 0 20px 15px;
}
.release-public {
  // height: 120px;
  box-sizing: border-box;
  padding: 25px 0 30px 0;
  border-bottom: 1px solid rgb(242, 243, 245);
}
.note {
  margin-top: 30px;
  h4 {
    margin-bottom: 20px;
  }
}
</style>
